<template>
    <!-- gnb -->
    <div class="gnb" :class="gnbOn">
        <div class="gnb-box ">
            <div class="user-info">
                <p v-text="constructionNm" />
                <P class="nm" v-text="name" />
            </div>

            <ul>
                <li>
                    <a @click="movePage('Main')">MAIN</a>
                </li>
                <li>
                    <a @click="movePage('Step1')">REGISTRATION</a>
                </li>
                <li>
                    <a @click="movePage('List')">FACE MAPPING LIST</a>
                </li>
                <li>
                    <a @click="movePage('SlideNATM')">NATM SLIDE SHOW</a>
                </li>
                <li>
                    <a @click="movePage('SlideTBM')">TBM SLIDE SHOW</a>
                </li>
                <li>
                    <a @click="movePage('ThreeDimensional')">3D MAP SHOW</a>
                </li>
                <li>
                    <a @click="logout()">LOGOUT</a>
                </li>
            </ul>

            <button class="btn-gnb-close" @click="gnbClose">
                <span class="blind">닫기</span>
            </button>
        </div>
    </div>
</template>
<!-- // gnb -->
<script>
import { mapActions, mapState } from 'vuex';
import {
    PARAM_OBJECT,
    JWT_TOKEN,
    JWT_REFRESH_TOKEN,
    MEMBER_ID,
    NAME,
    AUTO_YN,
    CONSTRUCTION_NM,
    CONSTRUCTION,
    TYPE
} from '../../const';
import LoginApi from '../../api/LoginApi';
export default {
    name: 'Gnb',
    components: {},
    props: {
        gnbOn: ''
    },
    data: () => {
        return {
            constructionNm: '',
            name: ''
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {},
    created() {},
    mounted() {
        this.constructionNm =
            localStorage.getItem(CONSTRUCTION_NM) == null || localStorage.getItem(CONSTRUCTION_NM) == 'null'
                ? ''
                : localStorage.getItem(CONSTRUCTION_NM);
        this.name = localStorage.getItem(NAME);
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        gnbClose() {
            this.$emit('getChildGnbShow');
        },
        async logout() {
            $('html').removeClass('off');
            const res = await LoginApi.logout();
            localStorage.removeItem(CONSTRUCTION_NM);
            localStorage.removeItem(CONSTRUCTION);
            localStorage.removeItem(NAME);
            localStorage.removeItem(TYPE);

            localStorage.removeItem(AUTO_YN);
            localStorage.removeItem(JWT_TOKEN);
            localStorage.removeItem(JWT_REFRESH_TOKEN);
            localStorage.removeItem(MEMBER_ID);

            this.$router.push({
                name: 'Login'
            });
        },
        movePage(target) {
            if (target == 'List') {
                localStorage.removeItem(PARAM_OBJECT);
            }

            $('html').removeClass('off');
            this.$router.push({
                name: target
            });
        }
    }
};
</script>
